/* global G */
import { curry, setKey } from 'lib/util'
import redirectSequence from '@gaia/sequence/module/adapter/router/redirect'
import routeComposition from '@gaia/trait/composition/route'

/**
 * Detail With Count Event Handler
 *
 * It executes module action detail() by "Fire-N-Forget"
 *
 * @param {Gaia.AppModule.Spec} module    current module composition object
 * @param {Gaia.Component.Spec} component component that triggered the event
 * @param {Event} event                   information about the triggered event
 * @param {Object} event.detail           custom event details
 * @param {string} event.detail.key       a model key to pass to {@link redirectSequence}
 * @returns {Promise<Event>} void
 */
const detailWithCount = async (module, component, event) => {
  try {
    const { key, count = event.detail?.item?.value?.count } = event.detail

    const moduleState = module[G.STATE]
    const { route } = component[G.CONFIGURATION]
    moduleState[G.ROUTE] = routeComposition(route.module, route.action)
    setKey(key, G.REF, module[G.MODEL][G.STATE])
    await redirectSequence(module)({ key, count })
  } catch (e) {
    console.error(e)
  }
  return event
}

export default curry(detailWithCount)
